import React from 'react';
import { createSanitizedHTML } from '../../utils/sanitize';

export default ({ video, image, message }) => (
  <div className="more-info-modal-inner">
    {video && <div className="responsive-video-container">{video}</div>}
    {image && <div className="more-info-modal-img" style={{ backgroundImage: `url(${image})` }} />}
    {message && (typeof message === 'string' ? <div dangerouslySetInnerHTML={createSanitizedHTML(message)} /> : message)}
  </div>
);
